export default class InsurancesPageEntity {

  constructor (
    id,
    title,
    insurancesIngress,
    insurancesText,
    insurancesSections,
    insurancesImage,
    insurancesLetterButton,
    insurancesLetterBox
  ) {
    this.id = id;
    this.title = title;
    this.insurancesIngress = insurancesIngress;
    this.insurancesText = insurancesText;
    this.insurancesSections = insurancesSections;
    this.insurancesImage = insurancesImage;
    this.insurancesLetterButton = insurancesLetterButton;
    this.insurancesLetterBox = insurancesLetterBox;
  }

}



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/insurances-page/insurances-page-entity.js
 **/